
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    
    function pCTGetCatalogsQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function pCTGetCatalogsInput (
        queryResultSettings: IQueryResultSettings, channelId:
            number,
            activeOnly:
            boolean
    ): IDataServiceRequest {
      const query = pCTGetCatalogsQuery().resultSettings(queryResultSettings);
      return query.createDataServiceRequestForOperation(
          'PCTGetCatalogs',
          true, 
            DataServiceEntities.PCTProductCatalogExtensionClass
          ,
          'true',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPCTProductCatalog' },
          {
          channelId: channelId,
            activeOnly: activeOnly
          }
      );
    }

    export function pCTGetCatalogsAsync (
        context: IContext, channelId:
            number,
            activeOnly:
            boolean
        ): AsyncResult<DataServiceEntities.IPCTProductCatalog[]> {
        const request = pCTGetCatalogsInput(
          context.queryResultSettings || {}, channelId, activeOnly);
        return callActionOrExecute<DataServiceEntities.IPCTProductCatalog[]>(request, context.callerContext);
        }
      
    function getContactsQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getContactsInput (
        queryResultSettings: IQueryResultSettings
    ): IDataServiceRequest {
      const query = getContactsQuery().resultSettings(queryResultSettings);
      return query.createDataServiceRequestForOperation(
          'GetContacts',
          false, 
            DataServiceEntities.ContactEntityExtensionClass
          ,
          'true',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IContactEntity' },
          {
          
          }
      );
    }

    export function getContactsAsync (
        context: IContext
        ): AsyncResult<DataServiceEntities.IContactEntity[]> {
        const request = getContactsInput(
          context.queryResultSettings || {});
        return callActionOrExecute<DataServiceEntities.IContactEntity[]>(request, context.callerContext);
        }
      
    function createContactQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function createContactInput (
        accountNum:
            string,
            firstName:
            string,
            lastName:
            string,
            email:
            string
    ): IDataServiceRequest {
      const query = createContactQuery();
      return query.createDataServiceRequestForOperation(
          'CreateContact',
          false, 
            DataServiceEntities.CreateContactResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICreateContactResponse' },
          {
          accountNum: accountNum,
            firstName: firstName,
            lastName: lastName,
            email: email
          }
      );
    }

    export function createContactAsync (
        context: IContext, accountNum:
            string,
            firstName:
            string,
            lastName:
            string,
            email:
            string
        ): AsyncResult<DataServiceEntities.ICreateContactResponse> {
        const request = createContactInput(accountNum, firstName, lastName, email);
        return callActionOrExecute<DataServiceEntities.ICreateContactResponse>(request, context.callerContext);
        }
      
    function updateContactQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function updateContactInput (
        contactPersonId:
            string,
            personId:
            string,
            firstName:
            string,
            lastName:
            string
    ): IDataServiceRequest {
      const query = updateContactQuery();
      return query.createDataServiceRequestForOperation(
          'UpdateContact',
          false, 
            DataServiceEntities.UpdateContactResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IUpdateContactResponse' },
          {
          contactPersonId: contactPersonId,
            personId: personId,
            firstName: firstName,
            lastName: lastName
          }
      );
    }

    export function updateContactAsync (
        context: IContext, contactPersonId:
            string,
            personId:
            string,
            firstName:
            string,
            lastName:
            string
        ): AsyncResult<DataServiceEntities.IUpdateContactResponse> {
        const request = updateContactInput(contactPersonId, personId, firstName, lastName);
        return callActionOrExecute<DataServiceEntities.IUpdateContactResponse>(request, context.callerContext);
        }
      
    function removeContactQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function removeContactInput (
        contactPersonId:
            string,
            personId:
            string
    ): IDataServiceRequest {
      const query = removeContactQuery();
      return query.createDataServiceRequestForOperation(
          'RemoveContact',
          false, 
            DataServiceEntities.RemoveContactResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IRemoveContactResponse' },
          {
          contactPersonId: contactPersonId,
            personId: personId
          }
      );
    }

    export function removeContactAsync (
        context: IContext, contactPersonId:
            string,
            personId:
            string
        ): AsyncResult<DataServiceEntities.IRemoveContactResponse> {
        const request = removeContactInput(contactPersonId, personId);
        return callActionOrExecute<DataServiceEntities.IRemoveContactResponse>(request, context.callerContext);
        }
      
    function getEligibleCustomersQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getEligibleCustomersInput (
        queryResultSettings: IQueryResultSettings
    ): IDataServiceRequest {
      const query = getEligibleCustomersQuery().resultSettings(queryResultSettings);
      return query.createDataServiceRequestForOperation(
          'GetEligibleCustomers',
          false, 
            DataServiceEntities.EligibleCustomerEntityExtensionClass
          ,
          'true',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IEligibleCustomerEntity' },
          {
          
          }
      );
    }

    export function getEligibleCustomersAsync (
        context: IContext
        ): AsyncResult<DataServiceEntities.IEligibleCustomerEntity[]> {
        const request = getEligibleCustomersInput(
          context.queryResultSettings || {});
        return callActionOrExecute<DataServiceEntities.IEligibleCustomerEntity[]>(request, context.callerContext);
        }
      
    function saveSessionCustomerQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function saveSessionCustomerInput (
        accountNum:
            string,
            contactPersonId:
            string,
            cartId:
            string
    ): IDataServiceRequest {
      const query = saveSessionCustomerQuery();
      return query.createDataServiceRequestForOperation(
          'SaveSessionCustomer',
          false, 
            DataServiceEntities.SaveSessionCustomerResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISaveSessionCustomerResponse' },
          {
          accountNum: accountNum,
            contactPersonId: contactPersonId,
            cartId: cartId
          }
      );
    }

    export function saveSessionCustomerAsync (
        context: IContext, accountNum:
            string,
            contactPersonId:
            string,
            cartId:
            string
        ): AsyncResult<DataServiceEntities.ISaveSessionCustomerResponse> {
        const request = saveSessionCustomerInput(accountNum, contactPersonId, cartId);
        return callActionOrExecute<DataServiceEntities.ISaveSessionCustomerResponse>(request, context.callerContext);
        }
      
    function getEligibleCustomersTotalQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getEligibleCustomersTotalInput (
        cartId:
            string,
            checkoutCartId:
            string
    ): IDataServiceRequest {
      const query = getEligibleCustomersTotalQuery();
      return query.createDataServiceRequestForOperation(
          'GetEligibleCustomersTotal',
          false, 
            DataServiceEntities.GetEligibleCustomersTotalResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetEligibleCustomersTotalResponse' },
          {
          cartId: cartId,
            checkoutCartId: checkoutCartId
          }
      );
    }

    export function getEligibleCustomersTotalAsync (
        context: IContext, cartId:
            string,
            checkoutCartId:
            string
        ): AsyncResult<DataServiceEntities.IGetEligibleCustomersTotalResponse> {
        const request = getEligibleCustomersTotalInput(cartId, checkoutCartId);
        return callActionOrExecute<DataServiceEntities.IGetEligibleCustomersTotalResponse>(request, context.callerContext);
        }
      
    function getUserInfoQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }

    
    export function getUserInfoInput (
        
    ): IDataServiceRequest {
      const query = getUserInfoQuery();
      return query.createDataServiceRequestForOperation(
          'GetUserInfo',
          false, 
            DataServiceEntities.GetUserInfoResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetUserInfoResponse' },
          {
          
          }
      );
    }

    export function getUserInfoAsync (
        context: IContext
        ): AsyncResult<DataServiceEntities.IGetUserInfoResponse> {
        const request = getUserInfoInput();
        return callActionOrExecute<DataServiceEntities.IGetUserInfoResponse>(request, context.callerContext);
        }
      